import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hf-container flex column justify-between" }
const _hoisted_2 = { class: "q-py-xs flex justify-around items-center" }

import { onMounted } from 'vue';
import TenantInfo from '@/components/TenantInfo.vue';
import BrandFooter from '@/components/BrandFooter.vue';
import { TenantLite } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';


import { defineComponent, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import colors from 'quasar/src/utils/colors/colors.js';import setCssVar from 'quasar/src/utils/css-var/set-css-var.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();



const name = ref('DefaultLayout');
const tenantLite = ref<TenantLite | null>(null);

  onMounted(async () => {
    loadTenantInfoLite();
  });

 async function loadTenantInfoLite() {
  try {
        tenantLite.value = tenantModule.tenantInfoLite || null;
        if (!tenantLite.value) {
          await tenantModule.loadTenantInfoLite();
          tenantLite.value = tenantModule.tenantInfoLite;
          if (tenantLite.value && tenantLite.value.primaryColor) {
            setCssVar('primary', tenantLite.value.primaryColor);
          }
          if (tenantLite.value && tenantLite.value.secondaryColor) {
            setCssVar('secondary', tenantLite.value.secondaryColor);
          }
        }
      } catch (error) {
        console.error(error);
      }
      if (!tenantLite.value) {
        router.push({ name: 'invalidtenant' });
      }
  }


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "shadow-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "bg-primary text-white"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (tenantLite.value && tenantLite.value.logo && '' != tenantLite.value.logo)
                ? (_openBlock(), _createBlock(_component_q_img, {
                    key: 0,
                    src: tenantLite.value.logo,
                    class: "logoImage",
                    contain: ""
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(TenantInfo, {
                    key: 1,
                    tenantLite: tenantLite.value
                  }, null, 8, ["tenantLite"]))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(BrandFooter, { showTermsOfUse: true })
    ]),
    _: 1
  }))
}
}

})